<footer class="container-fluid text-center mt-5  mb-3 m-footer">
  <a class="link" href="javascript:void(0)" *ngIf="showContactUs" (click)="openHelpDialog()">
    <span class="font-weight-bold">{{'FOOTER.P1' | translate}}</span>
    {{'FOOTER.LINK1' | translate}}
  </a>
  <a href="javascript:void(0)" *ngIf="false" class="mx-2" (click)="openTermOfUseDialog()">>
    {{'FOOTER.TERMS_USE' | translate}}
  </a>
</footer>



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.html